export default "__VITE_ASSET__BNqHudPw__"